import { authFetch } from "~/services/fetch";

export async function getOutServiceReason() {
    const response = await authFetch({
        url: '/device/out-of-service-reason',
        method: 'POST',
    })

    return response.data.data;
}